export enum FixtureType {
  Match = 'Match',
  Outright = 'Outright',
  Aggregate = 'Aggregate',
  Virtual = 'Virtual',
}

export enum FixtureStatus {
  Scheduled = 'Scheduled',
  Deleted = 'Deleted',
  Unknown = 'Unknown',
}

export enum ResultStatus {
  None = 'None',
  Winner = 'Winner',
  Pushed = 'Pushed',
  Loser = 'Loser',
  Placed = 'Placed',
  Partial = 'Partial',
}

export enum BetStatus {
  Won = 'Won',
  Lost = 'Lost',
  Voided = 'Voided',
  HalfWon = 'HalfWon',
  HalfLost = 'HalfLost',
}

export enum BetSlipRejectStatus {
  Rejected = 'Rejected',
  Delayed = 'Delayed',
}
